var RuTaskBuilderErrors = {

  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    if (errors.time_period && errors.time_period.length) {
      for (var i = 0, ilen = errors.time_period.length; i < ilen; i++) {
        err.push(I18n.t('time_period') + ' ' + errors.time_period[i]);
      }
    }

    if (errors.time_value && errors.time_value.length) {
      for (var i = 0, ilen = errors.time_value.length; i < ilen; i++) {
        err.push(I18n.t('time_value') + ' ' + errors.time_value[i]);
      }
    }

    return err;
  },

};

export default RuTaskBuilderErrors
